import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  panel: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    borderRadius: 0,
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(0, 3),
    minHeight: theme.spacing(9),
  },
  title: {
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  daiBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  daiLogo: {
    width: 80,
    height: 'auto',
  },
  preview: {
    fontWeight: 'bold',
    letterSpacing: '0.08em',
    color: theme.palette.dai.shinyBlue,
  },
  messages: {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    padding: theme.spacing(0, 3),
  },
  greeting: {
    width: '100%',
    maxWidth: 768,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop: theme.spacing(3),
  },
  greetingTitle: {
    color: theme.palette.dai.title,
    fontWeight: 700,
  },
  greetingSubtitle: {
    color: theme.palette.text.primary,
    fontWeight: 700,
    margin: theme.spacing(1, 0),
  },
  // Customiza as mensagens do componente do Dai chat só neste fluxo, sem alterar
  // o componente compartilhado. O projeto usa createGenerateClassName com
  // disableGlobal, então as classes mantêm o nome da regra (chatMessageAI) e
  // podem ser alvo por CSS aqui.
  daiMessages: {
    // Coluna central com largura máxima: as mensagens não esticam por toda a
    // largura do painel (sobretudo quando o chat ocupa a tela inteira, antes de
    // cadastrar a primeira IA).
    width: '100%',
    maxWidth: 768,
    marginLeft: 'auto',
    marginRight: 'auto',
    // `&&` dobra a especificidade para vencer o gridGap padrão (16px) do
    // container de mensagens do Dai. Gap menor para parecer uma troca de
    // mensagens (estilo WhatsApp).
    '&&': {
      gridGap: theme.spacing(1.5),
      gap: theme.spacing(1.5),
    },
    // Bolha da DAI (recebida): alinhada à esquerda, fundo cinza, canto superior
    // esquerdo reto.
    '& [class*="chatMessageAI"]': {
      maxWidth: '80%',
      flexGrow: 0,
      backgroundColor: theme.palette.cardSummaryBackground,
      padding: theme.spacing(1, 1.5),
      borderRadius: theme.spacing(0, 1.5, 1.5, 1.5),
    },
    // Bolha do usuário (enviada): alinhada à direita, fundo azul claro, canto
    // superior direito reto. Filho direto (`>`) para mirar só o Box da bolha e
    // não o Typography interno (chatMessageHumanText casaria no [class*=...]).
    '& > [class*="chatMessageHuman"]': {
      alignSelf: 'flex-end',
      maxWidth: '80%',
      flexGrow: 0,
      marginLeft: 0,
      backgroundColor: theme.palette.lightPastelBlue,
      padding: theme.spacing(1, 1.5),
      borderRadius: theme.spacing(1.5, 0, 1.5, 1.5),
    },
  },
  footer: {
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
    // Input centralizado com a mesma largura máxima das mensagens.
    '& > div': {
      width: '100%',
      maxWidth: 768,
    },
    // O ChatActions envolve o input num Box com `mb={1}` (8px) destinado aos
    // textos auxiliares — que não existem neste fluxo. Zeramos essa margem para
    // a base do input encostar no padding do footer e alinhar com a base dos
    // botões do InventoryPanel (footer de 24px).
    '& > div > div:first-child': {
      marginBottom: 0,
    },
  },
}))

export default useStyles
